import React, { useRef } from "react";
import { FiChevronDown, FiSearch } from "react-icons/fi";
import { RiArrowRightSLine } from "react-icons/ri";
import {
  Accordion,
  AccordionItem,
  AccordionItemButton,
  AccordionItemHeading,
  AccordionItemPanel,
  AccordionItemState,
} from "react-accessible-accordion";
import parse, { domToReact } from "html-react-parser";
import { faqSearch } from "../utils/api";
import { FaAngleLeft, FaAngleRight } from "react-icons/fa";
// import { useJitsu } from "@jitsu/react";

function FAQSection({
  helpArticles,
  setHelpArticles,
  setFAQSectionActive,
  searchTerm,
  setSearchTerm,
  settings,
  activeKeyword,
  onKeywordClick,
}) {
  // const { track } = useJitsu();
  const scrollRef = useRef(null);

  const scrollLeft = () => {
    if (scrollRef.current) {
      scrollRef.current.scrollBy({ left: -200, behavior: "smooth" });
    }
  };

  const scrollRight = () => {
    if (scrollRef.current) {
      scrollRef.current.scrollBy({ left: 200, behavior: "smooth" });
    }
  };

  const options = {
    replace: (domNode) => {
      if (domNode.name === "a" && domNode.attribs?.href) {
        const props = {
          ...domNode.attribs,
          target: "_blank",
          rel: "noopener noreferrer",
          style: {
            color: "#0000EE", // unvisited link blue
            textDecoration: "underline",
          },
        };
        return <a {...props}>{domToReact(domNode.children, options)}</a>;
      }
    },
  };

  return (
    <div>
      <div className="px-5 pt-4 pb-2">
        <div className="relative mb-5">
          <input
            type="text"
            placeholder="Search articles, keywords, etc."
            className="rounded-xl w-full p-3 text-sm"
            style={{ border: "1px solid #DFE0E1" }}
            onChange={(e) => setSearchTerm(e.target.value)}
            value={searchTerm}
            onKeyDown={(e) => {
              if (e.key === "Enter") {
                // track("faq_search");
                faqSearch(searchTerm, settings.merchant.id).then((resp) => {
                  setFAQSectionActive(true);
                  setHelpArticles(resp.data.data);
                });
              }
            }}
          />
          <FiSearch
            className="absolute right-4 top-2 mt-2 cursor-pointer"
            onClick={() => {
              // track("faq_search");
              faqSearch(searchTerm, settings.merchant.id).then((resp) => {
                setFAQSectionActive(true);
                setHelpArticles(resp.data.data);
              });
            }}
          />

          {settings.help_center_keywords.length > 0 && (
            <div className="relative my-4 flex items-center">
              <button
                className="mr-2 cursor-pointer"
                onClick={scrollLeft}
              >
                <FaAngleLeft color={settings["--site-widget-primary-color"]} />
              </button>

              <div
                ref={scrollRef}
                className="flex overflow-x-auto whitespace-nowrap scrollbar-hide py-1"
                style={{
                  gap: "10px",
                  scrollBehavior: "smooth",
                  scrollbarWidth: "none",
                  msOverflowStyle: "none",
                }}
              >
                <style>
                  {`
                    .scrollbar-hide::-webkit-scrollbar {
                        display: none;
                    }
                  `}
                </style>
                {settings.help_center_keywords.map((keyword, i) => {
                  return (
                    <div
                      key={i}
                      className="text-xs cursor-pointer text-center flex-shrink-0"
                      style={{
                        color: settings["--site-widget-primary-color"],
                      }}
                      onClick={() => {
                        if (onKeywordClick) {
                          onKeywordClick(keyword);
                        }
                      }}
                    >
                      <span
                        className="rounded-lg py-1 px-3 block"
                        style={{
                          background:
                            settings["--site-widget-primary-color-20"],
                          border:
                            activeKeyword === keyword
                              ? "1px solid " +
                                settings["--site-widget-primary-color"]
                              : "1px solid transparent", // transparent border prevents layout jump
                        }}
                      >
                        {keyword}
                      </span>
                    </div>
                  );
                })}
              </div>

              <button
                className="ml-2 cursor-pointer"
                onClick={scrollRight}
              >
                <FaAngleRight color={settings["--site-widget-primary-color"]} />
              </button>
            </div>
          )}
        </div>

        <Accordion allowZeroExpanded className="border-0">
          {helpArticles
            .filter((article) => {
              var content = String(parse(article.content));
              if (searchTerm === "") {
                return true;
              } else if (
                article.title
                  .toLowerCase()
                  .includes(searchTerm.toLowerCase()) ||
                content.toLowerCase().includes(searchTerm.toLowerCase())
              ) {
                return true;
              } else {
                return false;
              }
            })
            .map((item) => (
              <AccordionItem key={item.id} className="my-4 border border-[#DFE0E1] rounded-lg">
                <AccordionItemHeading>
                  <AccordionItemButton className="flex items-center p-4 text-sm">
                    {/* <AccordionItemState>
                      {({ expanded }) =>
                        expanded ? (
                          <div className="flex items-center">
                            <FiChevronDown className="mr-2" />
                          </div>
                        ) : (
                          <div className="flex items-center">
                            <RiArrowRightSLine className="mr-2" />
                          </div>
                        )
                      }
                    </AccordionItemState> */}
                    <p>{item.title}</p>
                  </AccordionItemButton>
                </AccordionItemHeading>
                <AccordionItemPanel className="text-xs mb-2 px-4">
                  {parse(item.content, options)}
                </AccordionItemPanel>
                {/* <hr className="my-2" /> */}
              </AccordionItem>
            ))}
        </Accordion>
      </div>
    </div>
  );
}

export default FAQSection;
